import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  PerformanceClientsArgs,
  PerformanceRetentionRangeArgs,
  PerformanceOverviewRangeArgs,
} from '../api/types/performanceStats.types';

import {
  fetchPerformanceClients,
  fetchPerformanceDailyRevenue,
  fetchPerformanceLeaderboards,
  fetchPerformanceRetention,
  fetchPerformanceMemberships,
  fetchPerformanceOverview,
  fetchPerformancePaymentMethods,
  fetchPerformanceRevenue,
  fetchPerformanceTrainerWork,
} from '../api/performanceStats.api';

/**
 * Task 6.4 — the key is `[args]` alone, the same shape as `bookingStats`:
 * `from`/`to` are civil days resolved against the ORGANIZATION's own zone on
 * the server, so no viewer zone belongs in the cache key.
 */
export const performanceStatsQueryKeys = createQueryKeys('performanceStats', {
  fetchOverview: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformanceOverview(args),
    queryKey: [args],
  }),
  // Task 6.7 — same key shape as `fetchOverview`.
  fetchRetention: (args: PerformanceRetentionRangeArgs) => ({
    queryFn: () => fetchPerformanceRetention(args),
    queryKey: [args],
  }),
  // PO 08.10. — same key shape as `fetchOverview`.
  fetchRevenue: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformanceRevenue(args),
    queryKey: [args],
  }),
  // PO 08.10. — same key shape as `fetchOverview`.
  fetchMemberships: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformanceMemberships(args),
    queryKey: [args],
  }),
  // PO 08.10.2026 (5.2) — same key shape as `fetchOverview`.
  fetchTrainerWork: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformanceTrainerWork(args),
    queryKey: [args],
  }),
  // PO 08.10.2026 (1.7) — same key shape as `fetchOverview`.
  fetchLeaderboards: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformanceLeaderboards(args),
    queryKey: [args],
  }),
  // PO 08.10.2026 (1.6, Q10) — same key shape as `fetchOverview`.
  fetchDailyRevenue: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformanceDailyRevenue(args),
    queryKey: [args],
  }),
  // PO 08.10.2026 (3.2, Q4) — same key shape as `fetchOverview`.
  fetchPaymentMethods: (args: PerformanceOverviewRangeArgs) => ({
    queryFn: () => fetchPerformancePaymentMethods(args),
    queryKey: [args],
  }),
  // PO 08.10.2026 — same key shape as `fetchOverview`.
  fetchClients: (args: PerformanceClientsArgs) => ({
    queryFn: () => fetchPerformanceClients(args),
    queryKey: [args],
  }),
});
